import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { HeadingXSmall } from 'baseui/typography';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { Vehicle } from '../../../types/vehicle';
import VehicleData from '../../shared/VehicleData';

type Props = {
  onClose: () => void;
  isOpen: boolean;
  label: string;
  vehicle: Vehicle;
};

function VehicleModal({ onClose, isOpen, label, vehicle }: Props) {
  const { theme, classes } = useStyles();

  return createPortal(
    <Modal
      animate
      closeable
      onClose={onClose}
      isOpen={isOpen}
      size="auto"
    >
      <ModalHeader>
        <FlexRow
          gap={theme.sizing.scale200}
          classNames={classes.centeredStart}
        >
          <HeadingXSmall margin={0}>{label}</HeadingXSmall>
        </FlexRow>
      </ModalHeader>
      <ModalBody>
        <FlexColumn gap={theme.sizing.scale800}>
          <VehicleData
            vehicle={vehicle}
            hiddenHourometer
            hiddenOdometer
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(VehicleModal);
